var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file RadioButton
 * @author (v_lichaoqing)
 */

import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { classPrefix } from '../../common/util';

import './RadioButton.less';

/**
 * 参数说明
 * value                可选，input 的 value
 * onHandleChange       可选，onHandleChange 切换radioButton时触发
 * name                 可选，input 的 name
 * disabled             可选，不可用态
 * checked              可选，选中状态
 * className            可选，RadioButton 追加类名
 * classPrefix          可选，类名前缀
 */

var RadioButton = function (_Component) {
    _inherits(RadioButton, _Component);

    function RadioButton() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RadioButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
            var onHandleChange = _this.props.onHandleChange;
            if (onHandleChange) {
                onHandleChange(e);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RadioButton, [{
        key: 'render',
        value: function render() {
            var _classnames;

            var _props = this.props,
                className = _props.className,
                value = _props.value,
                disabled = _props.disabled,
                children = _props.children,
                name = _props.name,
                classPrefix = _props.classPrefix,
                checked = _props.checked;

            var rBClassName = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-radio-button-root', true), _defineProperty(_classnames, classPrefix + '-radio-button-checked', !disabled && checked), _defineProperty(_classnames, classPrefix + '-radio-button-disabled', disabled), _defineProperty(_classnames, className, className), _classnames));
            return React.createElement(
                'label',
                { className: rBClassName },
                React.createElement(
                    'span',
                    { className: classPrefix + '-radio-box-wording' },
                    children
                ),
                React.createElement('input', {
                    type: 'radio',
                    name: name,
                    value: value,
                    disabled: disabled,
                    checked: checked,
                    onChange: this.onChange
                })
            );
        }
    }]);

    return RadioButton;
}(Component);

RadioButton.propTypes = {
    value: PropTypes.string,
    name: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    classPrefix: PropTypes.string,
    onHandleChange: PropTypes.func,
    checked: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
RadioButton.defaultProps = {
    classPrefix: classPrefix
};
export default RadioButton;